<div class="corepages">

  <div class="zui-wrapper">
    <app-Listingtable [targetList]="contactFieldList" [dataSources]="_returnList" [filterList]="contactFilterNameList"
      [FieldColumnToogle]="contactFieldColumnToogle" [modulename]="Module" [showPaycheck]="showPaycheck"
      [showPCC]="showPCC" [Filtername]="Filtername" [displayedColumns]="displayedColumns"
      [totalCount]="paginatorTotalLength" [pageIndex]="pageIndex" [pageSize]="pageSize"
      (pageChangeEvent)=CallNextPrevPageData($event) (dropListDropped)="dropListDropped($event)"
      (serachRecord)=SearchRecord($event) (filterNameClick)=OnFilterNameClick($event)
      (selectedRecordForAddFavorite)=FavoriteSelectedRecordAddForCore($event)
      (selectedRecordForDeleteFavorite)=FavoriteSelectedRecordForDeleteCore($event)
      (selectedRecordDelete)=DeleteSelectedRecordForCore($event)
      (selectedRecordSendtoPaychex)=SendtoPaychexRecordForContact($event)
      (selectedRecordSendtoPendingPatientPCC)=sendToPCCForContact($event) (selectedCustColumn)=onSubmitColumns($event)
      (addFilterEvent)=getapplyFilter($event) (showRightSideDetails)=getapplyFilter($event)
      (showRightSidePanel)=getshowRightSidePanel($event) (selectedTransactionId)=getselectedTransactionId($event)
      (addNewRecord)=addNew($event) (addFavoriteForFilter)=AddFavoriteForFilter($event)
      (deleteFavoriteForFilter)=DeleteFavoriteForFilter($event) (removeSelectedFilter)=RemoveSelectedFilter($event)
      [isAnyRecordAvailable]="isAnyRecordAvailable" [allids]="Allids" (CheckBoxClearExport)=GetExport($event)
      (selectedRecordArchive)=ArchiveSelectedRecordForContact($event)
      (selectedRecordActivate)=ActivateSelectedRecordForContact($event) (ArchivedFilterEvent)=ShowArchivedFilter()
      (SendtoAttachToTaskList)=CloseAttachToTaskList()>
    </app-Listingtable>
  </div>


</div>


<app-filter *ngIf="showFilter" [filterBindList]="selectedfilterList"
  [sendFromCoreFiltredName]="SendFilteredNameFromContact" (sendFilteredValue)=FilteredList($event)
  [ngClass]="{ open: showFilter  }" (closeFilter)=getCloseFilter($event)
  (closeFilterAfterSave)=getCloseFilterAfterSave($event) (clearApplyFilter)=clearAllApplyFilter($event)></app-filter>

<app-listing-detail *ngIf="showDetail" [transactionId]="selectedtransactionId" [ngClass]="{ open: showDetail  }"
  (closeDetail)=getCloseDetail($event)></app-listing-detail>



<app-add-listing *ngIf="addListing" (closeAdd)="getClose($event)" [ngClass]="{'open': addListing}"></app-add-listing>